import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "XlCaretBottom"
});
const _hoisted_1 = {
  t: "1663917659661",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "19595",
  width: "200",
  height: "200"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M197.568 256C128.16 256 107.2 301.824 150.592 358.24l282.752 367.424c43.424 56.48 113.92 56.416 157.344 0l282.72-367.424C916.864 301.792 895.68 256 826.464 256H197.568z",
  fill: "currentColor",
  "p-id": "19596"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var xlCaretBottom = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { xlCaretBottom as default };
